// extracted by mini-css-extract-plugin
export var hoverIcon = "survey-option-square-hover-module--hover-icon--JKHMZ";
export var hoverInput = "survey-option-square-hover-module--hover-input--2EwmR";
export var hoverOption = "survey-option-square-hover-module--hover-option--Uban+";
export var hoverWrapper = "survey-option-square-hover-module--hover-wrapper--lEhyW";
export var imgHover = "survey-option-square-hover-module--img-hover--jzx0e";
export var labelText = "survey-option-square-hover-module--label-text--KI86-";